import { useEffect, useState } from 'react'

const checkExistingSlot = (takeoverId: string): boolean => {
  if (!window.googletag?.apiReady) return false

  const slots = googletag.pubads().getSlots()
  const slot = slots.find((s) => s.getSlotElementId() === takeoverId)

  if (!slot) return false

  return slot.getResponseInformation() !== null
}

export const useTakeoverDetection = (takeoverId: string): boolean => {
  const [hasTakeover, setHasTakeover] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const handleSlotRenderEnded = (event: googletag.events.SlotRenderEndedEvent) => {
      if (event.slot.getSlotElementId() === takeoverId) {
        setHasTakeover(!event.isEmpty)
      }
    }

    const setupListener = () => {
      const alreadyHasAd = checkExistingSlot(takeoverId)
      if (alreadyHasAd) {
        setHasTakeover(true)
      }

      googletag.pubads().addEventListener('slotRenderEnded', handleSlotRenderEnded)
    }

    window.googletag = window.googletag || { cmd: [] }
    window.googletag.cmd.push(setupListener)

    return () => {
      if (window.googletag?.apiReady) {
        googletag.pubads().removeEventListener('slotRenderEnded', handleSlotRenderEnded)
      }
    }
  }, [takeoverId])

  return hasTakeover
}
